export function getSizeInMb(sizeInBytes) {
    
    return (sizeInBytes / (1024*1024)).toFixed(2);
}